import React from 'react';
import { ReporteContextProvider } from '../../Context/reporteContext';
import Reporte from './Reporte';
import withPermisont from '../../HOC/withPermisont';
import { VER_LISTADO_VENTAS } from '../../Constants/buscarDato';

const Index = () => {
  return (
    <>
      <ReporteContextProvider>
        <Reporte />
      </ReporteContextProvider>
    </>
  );
};

export default withPermisont(Index, VER_LISTADO_VENTAS);
